import { DineshAiComponent } from "@/components/dinesh_ai_gpay/indexPage";
import MarketingNewPaidForm from "@/components/marketingPages/MarketingNewPaidForm";
import axios from "axios";
import React, { useEffect, useState } from "react";
// import { PriceObj } from "./paid-video/[slug]";
import { getToken } from "@/marketingUtils/utils";
import { useRouter } from "next/router";
import mixpanel from "@/utils/mixpanel";

function getBottomInfo(source: string) {
  switch (source) {
    case "zepto":
      return "This is an Exclusive Offer for Zepto Customers";
    case "swiggy":
      return "This is an Exclusive Offer for Swiggy Customers";
    case "gpay":
      return "This is an Exclusive Offer for G-pay Customers";
    case "zomato":
      return "This is an Exclusive Offer for Zomato Customers";
    case "phonepe":
      return "This is an Exclusive Offer for PhonePe Users";
    case "paytm":
      return "This is an Exclusive Offer for Paytm Users";
    default:
      return undefined;
  }
}

export async function getServerSideProps(context: { params: { id: string } }) {
  const { id } = context.params;
  const abTestType = "all-2-field";

  try {
    const { data } = await axios.get(
      `${process.env.NEXT_PUBLIC_BASE_API}masterclasses/${id}?abtest=true&abtesttype=${abTestType}`,
      {
        headers: {
          "Accept-Encoding": "gzip",
        },
      }
    );

    return {
      props: {
        masterclassid: id,
        masterclass: data.data,

        abTestCounter: data.abTestCounter,
        abTestType,
      },
    };
  } catch (err) {
    return {
      props: {
        masterclassid: id,
        masterclass: {},
        abTestCounter: 0,
      },
    };
  }
}

export default function Learning1({
  masterclassid,
  masterclass,
  abTestCounter,
  abTestType,
}: {
  masterclassid: string;
  masterclass: any;
  abTestCounter: number;
  abTestType?: string;
}) {
  const router = useRouter();
  const source = router.query.source;
  const tkn = router.query.tkn;
  const bkt = router.query.bkt;
  const tokenObj = getToken((tkn as string) || undefined);
  const slots = masterclass?.slots;
  const activeSlot = slots?.find((slot: any) => {
    return slot.active;
  });
  const [showJoiningPopup, setShowJoiningPopup] = useState(false);
  const [leadCreated, setLeadCreated] = useState(false);
  const [partialData, setPartialData] = useState({
    id: null,
    masterclassSlotId: activeSlot?.id,
    masterclassId: masterclassid,
    source: router.query.source || "direct",
    comment: router.query.comment || "defalut_comment",
  });
  const activeWAGroup = activeSlot?.whatsappGroupLink;
  const [price, setPrice] = useState<PriceObj>({
    price: "0",
    discountedPrice: masterclass.discountedPrice,
    workshopTitle: masterclass.title,
    source: "default",
  });
  const handleRegisterClick = (value: boolean) => {
    setLeadModalOpen(value);
  };
  const [isLeadModalOpen, setLeadModalOpen] = useState(false);

  const uiPrice = tokenObj?.discountedPrice ?? price?.discountedPrice;
  const ctaText ="Enroll Now";
  const formCtaText ="Enroll Now"
  React.useEffect(() => {
    mixpanel.track("marketing_page", {
      page_location: window.location.href,
      page_referrer: document.referrer,
      masterclass: masterclass?.title,
      landing_page: "nadi_astrology_ai",
      masterclassId: masterclassid,
      platform: "astrolearn",
    });
  }, []);

  const bottomInfoText = getBottomInfo(source as string);
  const customCtaText =
    source === "zepto" ||
    source === "swiggy" ||
    source == "gpay" ||
    source == "zomato" ||
    source == "phonepe" ||
    source == "paytm" ? (
      <FormCtaComp />
    ) : undefined;

  return (
    <div>
      <div className="max-sm:fixed sm:hidden bottom-0 left-0 z-[60] right-0 w-full border border-t-white/20">
        <MarketingNewPaidForm
          type="normal"
          price={price}
          isFreeMc={!tkn}
          masterclass={masterclass}
          showEmailField={false}
          showNameField={false}
          mrktToken={tokenObj?.token}
          btnClass="!bg-gradient-to-r from-yellow-800 via-yellow-500 to-yellow-600 !text-white !border-none !animate-pulse"
          abTestType={abTestType}
          formHeading=""
          outerContainerClass={
            "!bg-opacity-50 backdrop-blur-sm !bg-black !border-none"
          }
          showPhoneLabel={false}
          redirectUrl={`https://astrolearn.co/${masterclassid}/redirect/thank-you`}
          bottomInfoText={bottomInfoText}
          bottomInfoTextClass="!text-white"
        />
      </div>
      <MarketingNewPaidForm
        isOpen={isLeadModalOpen}
        closeModal={() => setLeadModalOpen(false)}
        price={price}
        masterclass={masterclass}
        isFreeMc={!tkn}
        type="modal"
        showEmailField={false}
        showNameField={false}
        mrktToken={tokenObj?.token}
        btnClass="!bg-gradient-to-r from-yellow-800 via-yellow-500 to-yellow-600 !text-white !border-none"
        redirectUrl={`https://astrolearn.co/${masterclassid}/redirect/thank-you`}
        bottomInfoText={bottomInfoText}
      />
      <DineshAiComponent
        setLeadFormOpen={handleRegisterClick}
        activeSlot={activeSlot}
        ctaText={ctaText}
        formCtaText={formCtaText}
      />
    </div>
  );
}

const FormCtaComp = () => {
  return (
    <div className="text-lg">
      Register Now for
      <span className=" mx-1 relative">
        <div className="w-[103%] bg-red-500 h-[2px] absolute -rotate-[22deg] left-0 bottom-1/3 " />
        ₹999
      </span>
      FREE
    </div>
  );
};
